import React from "react";

export default function SubscriptionIcon() {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.33366 1.66663H16.667C17.1253 1.66663 17.5178 1.82996 17.8445 2.15663C18.1712 2.48329 18.3342 2.87551 18.3337 3.33329V12.5C18.3337 12.9583 18.1706 13.3508 17.8445 13.6775C17.5184 14.0041 17.1259 14.1672 16.667 14.1666H13.3337V18.3333L10.0003 16.6666L6.66699 18.3333V14.1666H3.33366C2.87533 14.1666 2.4831 14.0036 2.15699 13.6775C1.83088 13.3513 1.66755 12.9588 1.66699 12.5V3.33329C1.66699 2.87496 1.83033 2.48274 2.15699 2.15663C2.48366 1.83051 2.87588 1.66718 3.33366 1.66663ZM3.33366 10.8333H16.667V8.33329H3.33366V10.8333Z"
        fill="#3C3C3C"
      />
    </svg>
  );
}
